module.exports = __webpack_public_path__ + "static/img/avatar.cf721c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/yuexiu/avatar.jpg
// module id = bmvQ
// module chunks = 1